export const DEFAULT_STEPS = [
  {
    title: "Create your free account",
    description: "Sign up with your email or social media account.",
  },
  {
    title: "Enroll in this course",
    description: "Choose between a verified certificate or an audit track.",
  },
  {
    title: "Start learning immediately",
    description: "Access all of your course materials and begin learning.",
  },
];

export const DEFAULT_PROMO = {
  headline: "Ignite your career!",
  subtext: "Learn new skills and make big moves for your career.",
  ctaLabel: "Advance your career",
  infoText: "Offer does not apply to degree programs.",
  ctaElement: undefined,
};

export const DEFAULT_TITLE = "Start learning in 3 steps:";

export const DEFAULT_THEME = "dark";
